import React, { useEffect, useState } from "react";
import UpdateChallenegeVideo from "./UpdateChallenegeVideo";
import DeleteModal from "../../DeleteModal";
import { useLocation } from "react-router-dom";
import moment from "moment";
import ViewVideo from "./ViewVideo";

const ChallengeDetails = () => {
  const [showModal, setShowModal] = useState({
    update: false,
    deleteModal: false,
    video: false,
    videoData: "",
  });
  const { state } = useLocation();
  const { update, deleteModal, video, videoData } = showModal;

  useEffect(() => {
    setShowModal((prev) => ({
      ...prev,
      videoData: state?.Video,
    }));
  }, []);
  const hanldeClose = () => {
    setShowModal((prev) => ({ ...prev, deleteModal: false }));
  };
  const handleDelete = () => { };
  return (
    <>
      <div className="WrapperArea">
        <div className="WrapperBox">
          <div className="Small-Wrapper">
            <div className="TitleBox Border">
              <h4 className="Title">Challenge Details</h4>
            </div>
            <div className="CommonForm">
              <div className="form-group">
                <label>Title of Challenge </label>
                <p>{state?.title}</p>
              </div>
              <div className="form-group">
                <label>Category</label>
                <p>{state?.categoryData?.[0]?.categoryName}</p>
              </div>
              <div className="row">
                <div className="col-lg-6">
                  <div className="form-group">
                    <label>Start Date </label>
                    <p>{moment(state?.startDate).format("DD/MM/YYYY")}</p>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="form-group">
                    <label>Deadline Date </label>
                    <p>{moment(state?.endDate).format("DD/MM/YYYY")}</p>
                  </div>
                </div>
              </div>
              <div className="form-group">
                <label>No. of Prizes </label>
                <p>{state?.noOfPrizes}</p>
              </div>
              <div className="form-group">
                <label>Prize Details </label>
                <div
                  className="WhatYouLearnUl"
                  dangerouslySetInnerHTML={{ __html: state?.prizeDetails?.[0] }}
                ></div>
                {/* <ul>
                  <li>
                    Lorem ipsum dolor sit amet consectetur adipisicing elit.
                  </li>
                  <li>
                    Lorem ipsum dolor sit amet consectetur adipisicing elit.
                  </li>
                  <li>
                    Lorem ipsum dolor sit amet consectetur adipisicing elit.
                  </li>
                  <li>
                    Lorem ipsum dolor sit amet consectetur adipisicing elit.
                  </li>
                  <li>
                    Lorem ipsum dolor sit amet consectetur adipisicing elit.
                  </li>
                </ul> */}
              </div>
              <div className="form-group">
                <label>Participation Rules </label>
                <div
                  dangerouslySetInnerHTML={{
                    __html: state?.participationRules,
                  }}
                />
              </div>
              <div className="form-group">
                <label> Submission Guidelines </label>
                <p>{state?.submissionGuidelines}</p>
              </div>
            </div>
            <div className="TitleBox Border">
              <h4 className="Title">Video</h4>
            </div>
            <div className="TableList mt-4">
              <table className="table-hover">
                <thead>
                  <tr>
                    <th>Sr. No</th>
                    <th>Language</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>001</td>
                    <td>English</td>
                    <td>Video</td>
                    <td>
                      <div className="Actions">
                        <a
                          className="Eyes"
                          onClick={() =>
                            setShowModal((prev) => ({
                              ...prev,
                              video: true,
                            }))
                          }
                        >
                          <i className="fa-regular fa-eye" />
                        </a>
                        {/* <a
                          className="Edit"
                          onClick={() =>
                            setShowModal((prev) => ({ ...prev, update: true }))
                          }
                        >
                          <i className="fa-regular fa-pen-to-square" />
                        </a> */}
                        {/* <a
                          className="Delete"
                          onClick={() =>
                            setShowModal((prev) => ({
                              ...prev,
                              deleteModal: true,
                            }))
                          }
                        >
                          <i className="fa-regular fa-trash-can" />
                        </a> */}
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      {update && (
        <UpdateChallenegeVideo
          setShowModal={setShowModal}
          videoData={videoData}
        />
      )}
      {deleteModal && (
        <DeleteModal
          hanldeClose={hanldeClose}
          handleDelete={handleDelete}
          statement={"video "}
        />
      )}
      {video && <ViewVideo setShowModal={setShowModal} videoData={videoData} />}
    </>
  );
};

export default ChallengeDetails;
